module.exports = __webpack_public_path__ + "img/vue-react-unit-test.ec184884.png";